import { Col, Popover, Row } from 'antd';
import React, { ReactElement, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Panel from '../../../../../../../shared/components/card/Panel';
import FormFormattedAmount from '../../../../../../../shared/components/crmFormElement/FormFormattedAmount/FormFormattedAmount';
import { FormCheckBox, FormInputMobile, FormRadioButton, FormSelect, FormTextInput } from '../../../../../../../shared/components/crmFormElement/FormInput';
import FormMultiEmailInput from '../../../../../../../shared/components/crmFormElement/FormMultiEmailInput/FormMultiEmailInput';
import { DEFAULT_TEXT, GUTTOR_SPACE, MAX_AGE_LIMIT, MEMBER_AGE, PROVIDER_SPECIFIC_FEATURES } from '../../../../../../../shared/constants/commonConstants';
import { useSmoothScroll } from '../../../../../../../shared/hooks/useSmoothScroll';
import { Payer } from '../../../../../../../shared/models/payer.model';
import { RootState } from '../../../../../../../store';
import { LookUpState } from '../../../../../../../store/models/lookUpModel';
import { capitalizeFirstLetterAndRestSmallLatter, isDigitizationFeatureEnabled } from '../../../../../../../utils/utility';
import {
  billAmountGT0Validation,
  billMaxAmtValidation,
  createBillPackageIndexMap,
  customGTMEvent,
  disableHISPopulatedFields,
  findKeyValuePair,
  formatAmount,
  getBillTotal,
  getExactDoctorMatch,
  getIsPageNameDetail,
  getIsPageNameEdit,
  getIsPageNameEditDischarge,
  getIsPageNameNewAdmission,
  getIsPageNameReconsider,
  getPayerConfigPropValue,
  getProviderFeatureFlags,
  getPLTValue,
  getSignatureOnChangeMemberName,
  handleUserFocus,
  processHISBillData,
  shouldShowDayCareInDraftFlow,
  shouldShowDayCareTag,
  validateDateRange,
} from '../../../../service/crmUtils';
import { AdmissionContext } from '../../../AdmissionContext';
import ClaimDetailHeader from '../ClaimDetailHeader/ClaimDetailHeader';
import ApplicationDetail from '../../../../../../../shared/services/applicationDetail.service';
import { NewAdmissionState } from '../../../../../../../store/models/newAdmissionModel';
import { setDocotorList } from '../../../../../../../store/actions/lookUpAction';
import PanelCollapse from '../../../../../../../shared/components/collapse/PanelCollapse';
import FormInputNumber from '../../../../../../../shared/components/crmFormElement/FormInputNumber/FormInputNumber';
import FormAutoCompleteWithPrefix from '../../../../../../../shared/components/crmFormElement/FormAutoComplete/FormAutoCompleteWithPrefix';
import { setExtraFormValues, setIsNewBornCase, setMemberName, setSelectedDoctorList, setSelectedMemberId } from '../../../../../../../store/actions/newAdmissionAction';
import DatePickerInput from '../../../../../../../shared/components/crmFormElement/FormInputDatepicker';
import { InfoCircleFilled } from '@ant-design/icons';
import { actions, BILL_DETAIL_EMAIL, DAY_CARE_TYPE_DRAFT_KEYS, formInputStates, VALUE_NOT_UPDATED } from '../../../../../../../shared/constants/crmConstants';
import { cloneDeep, isEmpty } from 'lodash';
import ConsentPanel from '../../cardPanels/ConsentPanel';
import BillDetailsFieldsMap from '../../../../../../../config/BillDetailsFields.json';
import DatePickerLabel from '../../../../../../../shared/components/DatePicker/DatePickerLabel';
import { PayerInitialState } from '../../../../../../../store/models/payerListModel';
import { ControlConfig } from '../../../../../../../shared/models/formControlConfig.model';
import { setSuggestedValuesMap } from '../../../../../../../store/actions/hospitalAction';

const MultiPayerClaimDetails = ({ form, isLoading, location: { pathname } }: any): ReactElement => {
  useSmoothScroll('claim-details-multi');
  const dispatch = useDispatch();
  const { badTreatment } = useSelector((state: RootState): LookUpState => state?.lookUp);
  const { payerLookUp }: any = useSelector((state: RootState): RootState => state);
  const claimDetails = useSelector((state: RootState): any => state?.admissionDetails?.claimDetails || {});
  const payer = useSelector((state: RootState): Payer => state?.payerList?.payer || {});
  const emailConfiguration = useSelector((state: RootState): any => state?.mailBox?.hospitalConfiguration || {});
  const { isOnMailPayer, uniqueIdentifier } = useSelector((state: RootState): Payer => state?.payerList?.payer || {});
  const { admissionFormVal, selectedDraft, extraFormValues = {},
    memberId: memberIdEntered, isNewBornCase, isDraftSelected, patientConsentProceedClicked, consentOption,
    consentOptionStyle, isDaycareCase, isDateApplied } = useSelector((state: RootState): NewAdmissionState =>
      state.newAdmission || {});
  const {selectedInPatientDetail: { isDraftBtnClicked } } = useSelector((state: RootState): RootState => state);
  const { hisDoctorList } = useSelector((state: RootState): any => state.hospital);
  const { doctorList = [], roomType: payerRoomTypeOptions = [],
    proposedLineOfTreatment: pltOptions = [] } = payerLookUp[uniqueIdentifier] || {};
  const { selectedPatientDetail, suggestedValuesMap } = useSelector((state: RootState): any => state.hospital);
  const { formControlConfig } = useSelector((state: RootState): PayerInitialState => state.payerList);
  const isNewAdmissionPage = getIsPageNameNewAdmission(pathname);
  const [requiredField, setRequiredField] = useState('memberId');
  const admissionContext = useContext(AdmissionContext);
  const { claimDetailBackup } = admissionContext;
  const [selectedPayerEmails, setSelectedPayerEmails] = useState('');
  const { nextAllowStatus, payerClaimExtensionFields } = claimDetails || {};
  const [status] = nextAllowStatus || '';
  const isPageDetail = getIsPageNameDetail(pathname);
  const isEditDetailPage = getIsPageNameEdit(pathname) || getIsPageNameEditDischarge(pathname) || getIsPageNameReconsider(pathname);
  const parsedDraftData = selectedDraft?.rawDraft?.length > 0 ? JSON?.parse(selectedDraft?.rawDraft) : {};
  const { draftKey } = parsedDraftData || {};
  const [billDetail, setBillDetail] = useState<any>(cloneDeep(BILL_DETAIL_EMAIL));
  const [isPanelExpanded, setIsPanelExpanded] = useState(0);
  const { treatmentDetails, billDetails: HISBillDetails, doctorDetails } = selectedPatientDetail || {};
  const commonDetail = { form, isLoading };
  const billTotal = getBillTotal(HISBillDetails);
  const payerConfigValueObjectFromRedux = Object.values(formControlConfig || '');
  const customOptions: any = payerConfigValueObjectFromRedux?.filter(({ optionsType }: ControlConfig): boolean => optionsType === 'customOptions');
  const formattedTotal = HISBillDetails
    ? billTotal !== null
      ? formatAmount(billTotal)
      : VALUE_NOT_UPDATED
    : undefined;
  const [inputStates, setInputStates] = useState(formInputStates.emailForm);
  const [disableDocRegNo, setDisableDocRegNo] = useState(false);
  const isHISSearchEnabled = ApplicationDetail.instance.getIsHISSearchEnabled();
  const isPatientSignEnabled = ApplicationDetail.instance.getIsPatientSignEnabled();
  const isDoctorNameFilled = form?.getFieldValue()?.doctorName;
  const hasProcessedHisData = useRef(false);
  const [dateDifference, setDateDifference] = useState(0);
  const consentFontSize = consentOptionStyle?.fontSize;
  const consentFontFamily = consentOptionStyle?.fontFamily;

  const doctorName = isDraftSelected ? (admissionFormVal?.customerDetail?.doctorName ||
    admissionFormVal?.treatmentDetail?.doctorName) : isDoctorNameFilled;
  const { stayLength } = form.getFieldsValue(['stayLength']);
  const showDayCareInDraftFlow = shouldShowDayCareInDraftFlow(draftKey, DAY_CARE_TYPE_DRAFT_KEYS);
  const doctorRegNo = isDraftSelected ? admissionFormVal?.otherFormDetail?.doctorRegNo : form.getFieldValue('doctorRegNo');
  const appDetail = ApplicationDetail.instance;
  const providerSpecificFeatures = appDetail?.getProviderSpecificFeatures();
  const isIpNoMandatory = (getProviderFeatureFlags(providerSpecificFeatures,
    PROVIDER_SPECIFIC_FEATURES.IsIpNoMandatory) && (status === actions.DISCHARGE));

  useEffect((): any => {
    const payerData = JSON.parse(localStorage.getItem('payerConfiguration') || '{}');
    filterSelectedPayerEmails(payerData?.payers);
  }, []);

  useEffect((): void => {
    if (!doctorName) {
      dispatch(setSelectedDoctorList({}));
    }
  }, [doctorName]);

  useEffect((): any => {
    if (isDoctorNameFilled && !doctorName || !doctorRegNo || !doctorList ) {
      return;
    }
    const doctorListToSearch = isHISSearchEnabled && !isEmpty(hisDoctorList) ? hisDoctorList : doctorList;
    // Disable the field only if the entered registration number matches a doctor in the list.
    const isExactDoctorMatch = getExactDoctorMatch(doctorListToSearch, doctorName, doctorRegNo);
    if (isExactDoctorMatch) {
      setDisableDocRegNo(true);
    }
  }, [doctorRegNo, doctorList]);

  // Clearing the Day care type value when date changes only in New admission page
  //  and draft cases
  useEffect((): void => {
    if (isNewAdmissionPage && isDateApplied && !isDaycareCase) {
      form?.resetFields(['dayCareType']);
    }
  }, [isDateApplied]);

  // Clearing the Day care type value when date changes only in New admission page
  //  and draft cases
  useEffect((): void => {
    if (isNewAdmissionPage && isDateApplied && !isDaycareCase) {
      form?.resetFields(['dayCareType']);
    }
  }, [isDateApplied]);

  useEffect((): void => {
    if (isEmpty(treatmentDetails) || isEmpty(pltOptions)) {
      return;
    }

    const lineOfTreatment = treatmentDetails?.proposedLineOfTreatment;
    if (isEmpty(lineOfTreatment)) {
      return;
    }
    const pltValue = getPLTValue(lineOfTreatment, pltOptions);
    form.setFieldsValue({ proposedLineOfTreatment: pltValue });
  }, [payerLookUp]);

  useEffect((): void => {
    // to reset the flag when HIS data changes
    hasProcessedHisData.current = false;
  }, [selectedPatientDetail]);

  const prefillRoomType = (HISRoomType: string): void => {
    if (!isEmpty(payerRoomTypeOptions)) {
      const { payerMasterValue: payerRoomType } =
        findKeyValuePair(payerRoomTypeOptions, 'name', HISRoomType, true) || {};
      if (payerRoomType) {
        form.setFieldsValue({ payerRoomType });
      }
    }
  };

  useEffect((): void => {
    const HISRoomType = doctorDetails?.roomType;
    // call prefillRoomType only if payerRoomTypeOptions is not empty
    if (HISRoomType && !isEmpty(payerRoomTypeOptions)) {
      if (isNewAdmissionPage && !isDraftSelected) {
        prefillRoomType(HISRoomType);
      } else if (isEmpty(claimDetails.roomType) &&
        isEmpty(parsedDraftData?.newFormValue?.customerDetail?.payerRoomType)) {
        prefillRoomType(HISRoomType);
      }
    }
  }, [payerRoomTypeOptions, doctorDetails, claimDetails]);

  useEffect((): void => {
    // Skip processing if any conditions are not met
    if (isEmpty(HISBillDetails) || isPageDetail || !isPanelExpanded || hasProcessedHisData.current) {
      return;
    }
    const fieldIndexMap = createBillPackageIndexMap(billDetail);
    const { updateBillDetails, indicesToDisable } = processHISBillData(HISBillDetails, fieldIndexMap, BillDetailsFieldsMap);
    // to prefill the form with HIS Values
    if (Object.keys(updateBillDetails).length) {
      form.setFieldsValue(updateBillDetails);
    }
    // to disable fields that were filled with HIS data
    if (indicesToDisable.size) {
      disableHISPopulatedFields(indicesToDisable, setBillDetail);
    }
    // to track if billDetails is already updated with HIS data
    hasProcessedHisData.current = true;
  }, [HISBillDetails, isPanelExpanded]);

  useEffect((): any => {
    if (emailConfiguration?.payerEmails?.length > 0) {
      filterSelectedPayerEmails(emailConfiguration?.payerEmails);
    }
  }, [emailConfiguration]);

  useEffect((): any => {
    if (payer) {
      form.setFieldsValue({ payerCopy: payer.name});
    }
  }, [payer]);

  useEffect((): any => {
    dispatch(setDocotorList());
  }, []);

  const filterSelectedPayerEmails = (payerEmails: any = []): any => {
    const filteredPayerEmails = payerEmails.filter((pe: any): any => pe?.payerID === payer?.id);
    const { payerEmailID = '' } = filteredPayerEmails[0] || {};
    setSelectedPayerEmails(payerEmailID);
  };

  const checkRequiredField = (): any => {
    const { memberId, policyNumber } =  form.getFieldsValue(['policyNumber', 'memberId']);
    if (memberId && !policyNumber || admissionFormVal?.customerDetail?.memberId) {
      setRequiredField('memberId');
    } else if (!memberId && policyNumber || admissionFormVal?.customerDetail?.policyNumber) {
      setRequiredField('policyNumber');
    } else {
      setRequiredField('memberId');
    }
  };
  const isFormDisabled = (key: any): boolean | undefined =>
    !!(
      (
        (!isNewAdmissionPage) &&
        !form
      ) &&
      !payer?.isCorporatePayer &&
      form.getFieldsValue([key])[key] &&
      claimDetailBackup[key]
    );

  const onSelectNewBorn = (ev: any): any => {
    const patientName = form?.getFieldValue(['fullName']);
    const enteredMemberId = form?.getFieldValue(['memberId']);
    if (ev?.target?.checked) {
      dispatch(setIsNewBornCase(true));
      const formattedPatientName = `Baby of ${patientName || ''}`;
      form?.setFieldsValue({
        fullName: formattedPatientName,
        memberId: null,
      });
      dispatch(setMemberName(formattedPatientName));
      dispatch(setSelectedMemberId(enteredMemberId));
      customGTMEvent({
        event: 'Select Newborn Checkbox',
      });
    } else {
      dispatch(setIsNewBornCase(false));
      const modifiedString = patientName?.replace('Baby of ', '');
      form?.setFieldsValue({
        fullName: modifiedString,
        memberId: memberIdEntered,
      }); dispatch(setMemberName(modifiedString));
    }
    checkRequiredField();

    return;
  };
  const checkNewBornCase = (): boolean => {
    if (isNewBornCase || form?.getFieldsValue(['isNewBornCase'])['isNewBornCase']?.[0] === 'Yes' ||
      form?.getFieldsValue(['isNewBornCase'])['isNewBornCase'] === 'Yes') {
      return true;
    } else {
      return false;
    }
  };
  const checkDisabledNewBornCase = (): any => {
    const patientNameValue = form?.getFieldValue(['fullName']);
    const isPatientNameValid = !!patientNameValue;
    if (parsedDraftData?.isNewBornCaseDraft || isEditDetailPage || !isPatientNameValid) {
      return true;
    } else {
      return false;
    }
  };

  const isDateSelected = (): void => { // function to disable the length of stay once dates are selected in enhancement module
    return isEditDetailPage &&
      admissionFormVal?.customerDetail?.stayLength;
  };

  const setSelectedTime = (admitDate: any, dischargeDate: any, admitTime: any, dischargeTime: any): void => {
    form.setFieldsValue({ stayLength: [admitDate?.concat(' ', admitTime), dischargeDate?.concat(' ', dischargeTime)] });
  };

  const onChangeFullName = ({ target: { value } }: any): void => {
    dispatch(setMemberName(value));
    getSignatureOnChangeMemberName(value, patientConsentProceedClicked, consentOption, consentFontSize, consentFontFamily);
  };

  const handlePanelChange = (activeKey: any): any => {
    setIsPanelExpanded(activeKey ? 1 : 0);
  };
  const handleInputChange = (e: any, billDetailItem: any): void => {
    const numericValue = Number(e?.target?.value?.replace(/[^0-9.]/g, ''));
    const updatedDetail = { ...billDetailItem, billAmount: numericValue };
    form.setFieldsValue({ [billDetailItem.billPackageName]: updatedDetail });
  };

  const onSearchDoctor = (): void => {
    const { doctor } = extraFormValues;
    form.setFieldsValue({ doctorRegNo: '' });
    setDisableDocRegNo(false);
    if (doctor) {
      dispatch(setExtraFormValues({ ...extraFormValues, doctor: undefined }));
    } else {
      dispatch(setSelectedDoctorList({}));
    }
  };

  const onSelectDoctor = (...option: any[]): void => {
    const { key } = option[1];
    if (key) {
      const activeDoctorList = isHISSearchEnabled && hisDoctorList?.length > 0 ? hisDoctorList : doctorList;
      const selectedDoctor = activeDoctorList?.find(({ value }: any): boolean => value === parseInt(key, 10));
      dispatch(setSelectedDoctorList(selectedDoctor));
      const { registrationNo, name: doctor } = selectedDoctor;
      if (registrationNo) {
        form.setFieldsValue({ doctorRegNo: registrationNo });
        setDisableDocRegNo(true);
      }
      if (doctor) {
        form.setFieldsValue({ doctorName: doctor });
      }
    }
    dispatch(setExtraFormValues({ ...extraFormValues, doctor: option[1] }));
  };

  useEffect((): any => {
    if (!isEmpty(suggestedValuesMap) && formattedTotal !== undefined) {
      dispatch(setSuggestedValuesMap({
        ...suggestedValuesMap,
        claimedAmount: formattedTotal,
      }));
    }
  }, [formattedTotal]);

  return (
    <Panel title="Claim Details" className="claim-details-multi">
      {
        !isNewAdmissionPage ? <ClaimDetailHeader /> : null
      }
      <div className="multipayerPanel">
        <PanelCollapse accordion={true}
          expandIconPosition="right"
          defaultActiveKey={['1']}
          keyName="1"
          fontSizeClassName="multiPayerMainPanel"
          header="Member Details">
          <Row gutter={GUTTOR_SPACE}>
            <FormTextInput detail={{
              ...commonDetail,
              key: 'fullName',
              size: 12,
              isName: true,
              disabled: isFormDisabled('fullName') || checkNewBornCase(),
              onFocus: (): any => handleUserFocus('fullName', setInputStates, true ),
              onBlur: (): any => handleUserFocus('fullName', setInputStates, false ),
              isShowSuggestedValue: inputStates.fullName.isShowSuggestedValue,
              maxLength: 50,
              onChange: (event: any): any => onChangeFullName(event),
              leftFooterText: <div className="newBornCheckboxDiv">
              {!isPageDetail && <FormCheckBox detail ={{
                    ...commonDetail,
                    key: 'isNewBornCase',
                    checked: false,
                    options: [{ value: 'Yes', onChange: onSelectNewBorn, name: 'Select this for Newborn Baby Preauthorization Request'}],
                    hideLabel: true,
                    disabled: checkDisabledNewBornCase(),
                  }}
                  />}
                </div>,
            }} />
            <FormInputMobile detail={{
              ...commonDetail,
              key: 'mobile',
              size: 12,
              disabled: isFormDisabled('mobile'),
              onFocus: (): any => handleUserFocus('mobile', setInputStates, true ),
              onBlur: (): any => handleUserFocus('mobile', setInputStates, false ),
              isShowSuggestedValue: inputStates.mobile.isShowSuggestedValue,
            }} />
            <FormInputNumber detail={{
              ...commonDetail,
              key: 'memberAge',
              size: 12,
              disabled: isFormDisabled('memberAge'),
              regex: MEMBER_AGE,
              maxLength: MAX_AGE_LIMIT,
              isMemberAge: true,
              onFocus: (): any => handleUserFocus('memberAge', setInputStates, true ),
              onBlur: (): any => handleUserFocus('memberAge', setInputStates, false ),
              isShowSuggestedValue: inputStates.memberAge.isShowSuggestedValue,
            }} />
            <FormTextInput detail={{
              ...commonDetail,
              suffixTestId: 'form',
              key: 'memberId',
              size: 12,
              required: (requiredField === 'memberId') && !checkNewBornCase(),
              onChange: checkRequiredField,
              disabled: isFormDisabled('memberId') || checkNewBornCase(),
              onFocus: (): any => handleUserFocus('memberId', setInputStates, true ),
              onBlur: (): any => handleUserFocus('memberId', setInputStates, false ),
              isShowSuggestedValue: inputStates.memberId.isShowSuggestedValue,
            }} />
            <FormTextInput detail={{
              ...commonDetail,
              key: 'policyNumber',
              size: 12,
              regex: /[^a-zA-Z\d\\\-/_]*/gm,
              required: (requiredField === 'policyNumber') || checkNewBornCase(),
              onChange: checkRequiredField,
              disabled: isFormDisabled('policyNumber'),
              onFocus: (): any => handleUserFocus('policyNumber', setInputStates, true ),
              onBlur: (): any => handleUserFocus('policyNumber', setInputStates, false ),
              isShowSuggestedValue: inputStates.policyNumber.isShowSuggestedValue,
            }} />
            <FormTextInput detail={{
              ...commonDetail,
              key: 'employeeId',
              size: 12,
              disabled: isFormDisabled('employeeId'),
              regex: /[^a-zA-Z\d\-]*/gm,
              onFocus: (): any => handleUserFocus('employeeId', setInputStates, true ),
              onBlur: (): any => handleUserFocus('employeeId', setInputStates, false ),
              isShowSuggestedValue: inputStates.employeeId.isShowSuggestedValue,
            }} />
            <FormTextInput detail={{
              ...commonDetail,
              key: 'payerCopy',
              size: 12,
              disabled: true,
              onFocus: (): any => handleUserFocus('payerCopy', setInputStates, true ),
              onBlur: (): any => handleUserFocus('payerCopy', setInputStates, false ),
              isShowSuggestedValue: inputStates.payerCopy.isShowSuggestedValue,
            }} />
            <FormSelect detail={{
              ...commonDetail,
              key: 'insurerName',
              size: 12,
              disabled: false,
              options: (payerLookUp[payer?.uniqueIdentifier]?.['insurerName'] || []),
              allowOptionDisabled: true,
              onFocus: (): any => handleUserFocus('insurerName', setInputStates, true ),
              onBlur: (): any => handleUserFocus('insurerName', setInputStates, false ),
              isShowSuggestedValue: inputStates.insurerName.isShowSuggestedValue,
            }} />
            <FormTextInput detail={{
              ...commonDetail,
              key: 'corporateName',
              size: 12,
              disabled: isFormDisabled('corporateName'),
              regex: /[^A-Za-z\b\-//()-*_,:;.&+|]*/gm,
              required: false,
              onFocus: (): any => handleUserFocus('corporateName', setInputStates, true ),
              onBlur: (): any => handleUserFocus('corporateName', setInputStates, false ),
              isShowSuggestedValue: inputStates.corporateName.isShowSuggestedValue,
              isMaxLengthNotApplicable: true,
            }} />
            {isOnMailPayer ?
              <FormTextInput detail={{
                ...commonDetail,
                key: 'inPatientNumber',
                size: 12,
                required: isIpNoMandatory || false,
                labelClass: 'mb-0',
                onFocus: (): any => handleUserFocus('inPatientNumber', setInputStates, true ),
                onBlur: (): any => handleUserFocus('inPatientNumber', setInputStates, false ),
                isShowSuggestedValue: inputStates.inPatientNumber.isShowSuggestedValue,
              }} /> : <></>
            }
            <FormTextInput detail={{
              ...commonDetail,
              key: 'emailId',
              size: 12,
              type: 'email',
              disabled: isFormDisabled('emailId'),
              maxLength: 50,
              onFocus: (): any => handleUserFocus('emailId', setInputStates, true ),
              onBlur: (): any => handleUserFocus('emailId', setInputStates, false ),
              isShowSuggestedValue: inputStates.emailId.isShowSuggestedValue,
            }} />
          </Row>

        </PanelCollapse>
        <PanelCollapse accordion={true}
          expandIconPosition="right"
          defaultActiveKey={['1']}
          keyName="1"
          fontSizeClassName = "multiPayerMainPanel"
          header="Treatment Details">
          <Row gutter={GUTTOR_SPACE}>
            <DatePickerInput detail={{
              ...commonDetail,
              key: 'stayLength',
              size: 14,
              dodRightLimit: 182,                // length of stay cannot be more than 6 Months
              setval: (admitDate: any, dischargeDate: any, admitTime: any, dischargeTime: any): any => {
                setSelectedTime(admitDate, dischargeDate, admitTime, dischargeTime);
              },
              setDifference : (noOfDays: number): any => { setDateDifference(noOfDays); },
              showNow: true,
              disabled: isFormDisabled('stayLength') || isDateSelected(),
              claimForm: form,
              isDetailPage: isPageDetail,
              onFocus: (): any => handleUserFocus('stayLength', setInputStates, true ),
              onBlur: (): any => handleUserFocus('stayLength', setInputStates, false ),
              isShowSuggestedValue: inputStates.stayLength.isShowSuggestedValue,
              isNewAdmissionPage,
              rules: [{ validator: validateDateRange }],
            }} />
            <Col md={dateDifference === 1 ? isNewAdmissionPage ? 4 : 1 : 9}>
            { isNewAdmissionPage &&
                <Row className="inpatient left-6">
                  <Col className="info-circle">
                    <Popover
                      content={'Inpatient | Daycare: Based on DOA & DOD'}
                      overlayClassName="custom-tooltip-datepicker"
                      placement="bottom"
                    >
                      <InfoCircleFilled />
                    </Popover>
                  </Col>
                  <DatePickerLabel dateDifference={dateDifference} />
                </Row>
              }
            </Col>
            {shouldShowDayCareTag(isPageDetail, payerClaimExtensionFields, isDaycareCase,
              claimDetails, stayLength, showDayCareInDraftFlow, isDraftBtnClicked) &&
              <FormSelect detail={{
                ...commonDetail,
                key: 'dayCareType',
                size: isNewAdmissionPage ? 6 : 9,
                options: getPayerConfigPropValue(customOptions, 'options', 'Pre-Auth Type') || [],
                nextStatus: status,
                onFocus: (): void => handleUserFocus('dayCareType', setInputStates, true),
                onBlur: (): void => handleUserFocus('dayCareType', setInputStates, false),
                isShowSuggestedValue: inputStates.dayCareType.isShowSuggestedValue,
              }} />
            }
            <FormRadioButton detail={{
              ...commonDetail,
              key: 'proposedLineOfTreatment',
              size: 24,
              options: pltOptions,
              isShowSuggestedValue: !!treatmentDetails,
            }} />
            <FormSelect detail={{
              ...commonDetail,
              key: 'admissionType',
              size: 12,
              allowClear: true,
              options: ['Planned', 'Emergency'],
              onFocus: (): void => handleUserFocus('admissionType', setInputStates, true ),
              onBlur: (): void => handleUserFocus('admissionType', setInputStates, false ),
              isShowSuggestedValue: inputStates.admissionType.isShowSuggestedValue,
            }}
            />
            <FormSelect detail={{
              ...commonDetail,
              key: 'payerRoomType',
              size: 12,
              options: payerRoomTypeOptions,
              showSearch: true,
              onFocus: (): any => handleUserFocus('payerRoomType', setInputStates, true ),
              onBlur: (): any => handleUserFocus('payerRoomType', setInputStates, false ),
              isShowSuggestedValue: inputStates.payerRoomType.isShowSuggestedValue,
            }} />
            <FormSelect detail={{
              ...commonDetail,
              key: 'procedure',
              size: 12,
              options: [],
              showSearch: true,
              mode: 'tags',
              isBadValueCheck: true,
              badValues: badTreatment || [],
              onlyAlphaNumeric: true,
              disabled: isFormDisabled('procedure'),
            }} />
            <FormSelect detail={{
              ...commonDetail,
              key: 'diagnosis',
              size: 12,
              showSearch: true,
              mode: (payer?.shortName === 'HDFC' && process.env.REACT_APP_HDFC_FEATURES === 'true') ? 'multiple' : 'tags',
              onFocus: (): any => handleUserFocus('diagnosis', setInputStates, true ),
              onBlur: (): any => handleUserFocus('diagnosis', setInputStates, false ),
              isShowSuggestedValue: inputStates.diagnosis.isShowSuggestedValue,
            }} />
            <FormAutoCompleteWithPrefix detail={{
              ...commonDetail,
              key: 'doctorName',
              size: 24,
              options: doctorList?.filter(
                (doctor: any): boolean =>
                  !doctor?.name?.toLowerCase()?.startsWith(DEFAULT_TEXT),
              ),
              isName: true,
              onSearch: onSearchDoctor,
              onSelect: onSelectDoctor,
              isPrefixRequired: true,
              showSearch: true,
              className: 'doctorClass',
              isMultiPayer: true,
              isDetailPage: isPageDetail,
              prefix: 'Dr. ',
              onFocus: (): any => handleUserFocus('doctorName', setInputStates, true ),
              onBlur: (): any => handleUserFocus('doctorName', setInputStates, false ),
              isShowSuggestedValue: inputStates.doctorName.isShowSuggestedValue,
            }} />
            <FormTextInput detail={{
              ...commonDetail,
              key: 'doctorRegNo',
              size: 12,
              regex: /[^a-zA-Z\d\-]*/gm,
              disabled: disableDocRegNo,
              onFocus: (): any => handleUserFocus('doctorRegNo', setInputStates, true ),
              onBlur: (): any => handleUserFocus('doctorRegNo', setInputStates, false ),
              isShowSuggestedValue: inputStates.doctorRegNo.isShowSuggestedValue,
            }} />
          </Row>
        </PanelCollapse>
      <PanelCollapse accordion={true}
        expandIconPosition="right"
        defaultActiveKey={['1']}
        keyName="1"
        fontSizeClassName="multiPayerMainPanel"
        header="Billing Details">
        <Row gutter={GUTTOR_SPACE}>
          <FormFormattedAmount
            detail={{
              ...commonDetail,
              key: 'claimedAmount',
              size: 12,
              addonBefore: '₹ ',
              allowNegative: false,
              onFocus: (): any => handleUserFocus('claimedAmount', setInputStates, true ),
              onBlur: (): any => handleUserFocus('claimedAmount', setInputStates, false ),
              isShowSuggestedValue: inputStates.claimedAmount.isShowSuggestedValue,
            }}
          />
        </Row>
        <PanelCollapse
          accordion={true}
          expandIconPosition="right"
          activeKey={isPanelExpanded}
          keyName="1"
          header="Other Bill Details (Optional)"
          fontSizeClassName="multiPayerSubPanel"
          onChange={handlePanelChange}
        >
          {billDetail.map((billDetailItem: any): any => (
            <Row key={billDetailItem.billPackageName} gutter={GUTTOR_SPACE} align="middle">
              <Col md={24}>
                <FormFormattedAmount
                  id={billDetailItem.billPackageName}
                  value={form.getFieldValue(billDetailItem.billPackageName)?.value || ''}
                  onChange={(e: any): any => handleInputChange(e, billDetailItem)}
                  detail={{
                    ...commonDetail,
                    key: billDetailItem.billPackageName,
                    required: false,
                    size: 24,
                    disabled: billDetailItem.disabled,
                    addonBefore: '₹ ',
                    allowNegative: false,
                    isBillDetail: true,
                    rules: [billAmountGT0Validation(billDetailItem.billPackageName), billMaxAmtValidation(billDetailItem.billPackageName)],
                  }}
                  placeholder={`Enter ${billDetailItem.billPackageName.toLowerCase()}`}
                />
              </Col>
            </Row>
          ))}
        </PanelCollapse>
      </PanelCollapse>
        {(isDigitizationFeatureEnabled(isPatientSignEnabled) && isNewAdmissionPage) && <ConsentPanel formValues={form} />}
      </div>
      {!isPageDetail &&
        <Row gutter={GUTTOR_SPACE} className="margin-top-12">
          <Col className="muti-payer-config-emails-wrapper">
            <p>{`Your ${capitalizeFirstLetterAndRestSmallLatter(nextAllowStatus?.[0]) || 'New admission'} will be sent to the following email`}</p>
            <p>
              {selectedPayerEmails?.length > 0 ? selectedPayerEmails : '-'}
            </p>
          </Col>
        </Row>
      }

      <Row gutter={GUTTOR_SPACE}>
        {!isPageDetail &&
          <FormMultiEmailInput detail={{
            ...commonDetail,
            key: 'additionalEmails',
            size: 24,
            compareWithAdditionlData: selectedPayerEmails.split(','),
          }} />
        }
      </Row>
    </Panel>
  );
};
export default withRouter(MultiPayerClaimDetails);
